import { Col, Row } from "react-bootstrap";
import Pagination from "react-js-pagination";

import ViewItemsPerPage from "../ViewItemsPerPage";

const PaginationWithControls = ({
  pageIndex,
  pageSize,
  listCount,
  onChangePageIndex,
  onChangePageSize,
}: {
  pageIndex: number;
  pageSize: number;
  listCount: number;
  onChangePageIndex: (pageNumber: number) => void;
  onChangePageSize: (pageSize: number) => void;
}) => {
  return (<>
    <Row>
      <Col>
        <p className="py-2">
          Results: {pageIndex + 1} - {(pageIndex + 1) * pageSize} of {listCount}
        </p>
      </Col>
      <Col>
        <Pagination
          activePage={pageIndex + 1}
          totalItemsCount={listCount}
          itemsCountPerPage={pageSize}
          onChange={onChangePageIndex}
          itemClass="page-item"
          linkClass="page-link"
          firstPageText="First"
          lastPageText="Last"
        />
      </Col>
      <Col className="text-end">
        <ViewItemsPerPage
          selectedPageSize={pageSize}
          onSelectPageSize={onChangePageSize}
        />
      </Col>
    </Row>
  </>);
};

export default PaginationWithControls;
